import * as React from 'react';

export function IconAmex(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 54 32" fill="none" {...props}>
      <title>American Express</title>
      <g clipPath="url(#prefix__clip0_16_36)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0h53.333v32H0V0z"
          fill="#006FCF"
        />
        <path
          d="M12.07 13.713l1.126 2.73h-2.243l1.117-2.73zm23.382.114h-4.33v1.202h4.26v1.803h-4.251v1.34h4.33v1.076l3.021-3.265-3.022-3.404-.008 1.248zm-20.455-3.403h5.811l1.291 2.813 1.195-2.822h15.084l1.568 1.73 1.621-1.73h6.929l-5.119 5.602 5.067 5.568h-7.032l-1.568-1.73-1.636 1.73H13.611l-.718-1.73H11.25l-.72 1.73H4.84l4.78-11.17h4.988l.388.009h.001zm12.6 1.568h-3.256l-2.181 5.143-2.364-5.144h-3.232v6.996l-2.997-6.998h-2.898l-3.465 8.018h2.262l.719-1.73h3.775l.72 1.73h3.956v-5.723l2.546 5.732h1.731l2.531-5.714v5.716h2.12l.036-8.03-.002.002v.002zm13.587 4.025l3.681-4.025h-2.65l-2.33 2.51-2.25-2.51h-8.574v8.025h8.452l2.347-2.528 2.251 2.528h2.729l-3.655-4h-.001z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_16_36">
          <path fill="#fff" d="M0 0h53.333v32H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
